
import { defineComponent } from 'vue';
import { WidgetInstance } from 'friendly-challenge';

interface MyObjData {
  myCustomWidget: WidgetInstance | null;
  fallback: boolean;
}

export default defineComponent({
  props: {
    sitekey: String,
    locale: String,
  },

  data(): MyObjData {
    return { myCustomWidget: null, fallback: true };
  },

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options: any = {
      doneCallback: this.doneCallback,
      errorCallback: this.errorCallback,
      puzzleEndpoint: 'https://api.friendlycaptcha.com/api/v1/puzzle',
      sitekey: this.sitekey,
      language: this.locale,
      startMode: 'auto',
    };

    this.myCustomWidget = new WidgetInstance(this.$refs.frHolder as HTMLElement, options);
  },

  methods: {
    // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-explicit-any
    doneCallback(solution: any) {
      this.$emit('verify', solution);
    },

    // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-explicit-any
    errorCallback(err: any) {
      console.log('There was an error when trying to solve the Captcha.');
      console.log(err);

      if (this.fallback && err.error?.rawError?.message.indexOf('403') >= 0) {
        this.myCustomWidget?.destroy();
        this.fallback = false;
        (this.$refs.frHolder as HTMLElement).innerHTML = '';

        const options: any = {
          doneCallback: this.doneCallback,
          errorCallback: this.errorCallback,
          puzzleEndpoint: 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle',
          sitekey: this.sitekey,
          language: this.locale,
          startMode: 'auto',
        };

        this.myCustomWidget = new WidgetInstance(this.$refs.frHolder as HTMLElement, options);
        // this.myCustomWidget.start();
      }
    },

    reset() {
      if (this.myCustomWidget != null) {
        this.myCustomWidget.reset();
      }
    },

    start() {
      if (this.myCustomWidget != null) {
        this.myCustomWidget.start();
      }
    },
  },
});
